import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=68a28e32&scoped=true&lang=pug&"
import script from "./ProductOption.vue?vue&type=script&lang=js&"
export * from "./ProductOption.vue?vue&type=script&lang=js&"
import style0 from "./ProductOption.vue?vue&type=style&index=0&id=68a28e32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a28e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a28e32')) {
      api.createRecord('68a28e32', component.options)
    } else {
      api.reload('68a28e32', component.options)
    }
    module.hot.accept("./ProductOption.vue?vue&type=template&id=68a28e32&scoped=true&lang=pug&", function () {
      api.rerender('68a28e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/product/ProductOption.vue"
export default component.exports